import React from 'react';
import { useAppNavigate } from '../../../../Hooks/back/useAppNavigate';
import dayjs from 'dayjs';
import ExtendBottomSheet from './ExtendBottomSheet';
import { useDispatch, useSelector } from 'react-redux';
import { BottomSheetActions } from '../../../../Reducer/BottomSheetReducer';
import { CommonActions } from '../../../../Reducer/CommonReducer';
import { PermitActions } from '../../../../Reducer/PermitReducer';
import Icon from '../../../../Assets/Icon/CustomIcon';

export default function PermitList({ data, SaveLogic1 }) {
  const { navigate } = useAppNavigate();
  const dispatch = useDispatch();
  const bottomSheetState = useSelector((state) => state.bottomSheet);
  const { userInfo } = useSelector((state) => state.BaseInfo);

  const statusBadgeClass = {
    반려: 'bg-red-500',
    요청: 'bg-green-500',
    승인: 'bg-badge-purple',
    만료: 'bg-yellow-500',
    대기: 'bg-slate-400',
    서명완료: 'bg-pink-400',
  };

  if (!data || data.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="text-base leading-relaxed text-slate-500">
          현재 선택한 날짜에 작업허가서가 없습니다.
          <br />
          아래 버튼을 눌러 작성해주세요.
        </p>
      </div>
    );
  }

  return (
    <>
      <ul className="flex flex-col gap-3 pb-4">
        {data.map((item) => (
          <li
            key={item.pmCd}
            onClick={() => {
              dispatch(CommonActions.increaseStep());
              if (item.gubun === '반려' && item.userId === userInfo?.id) {
                navigate(`/M_Permit/write/${item.pmCd}`, {
                  state: { from: '/M_Permit' },
                });
              } else {
                navigate(`/M_Permit/detail/${item.pmCd}`, {
                  state: { from: '/M_Permit' },
                });
              }
            }}
            className="group bg-card-light shadow-soft relative flex cursor-pointer items-start gap-4 rounded-xl border border-slate-100 p-4 transition-all active:scale-[0.98]"
          >
            <div className="relative shrink-0">
              <div className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full border border-slate-200 bg-slate-100">
                <span className="material-symbols-rounded text-3xl text-slate-300">
                  <Icon.User />
                </span>
              </div>
              <span
                className={`absolute -bottom-1 left-1/2 z-10 -translate-x-1/2 rounded-full px-2 py-0.5 text-[10px] font-bold whitespace-nowrap text-white shadow-sm ${statusBadgeClass[item.gubun] || 'bg-slate-500'} `}
              >
                {item.gubun}
              </span>
            </div>

            <div className="min-w-0 flex-1 pt-0.5">
              <div className="mb-0.5 flex items-start justify-between">
                <p className="truncate pr-2 font-bold text-slate-900">
                  {item.userNm}
                </p>
                <span className="shrink-0 text-sm font-bold text-slate-900">
                  {dayjs(item.workStartDate).format('HH:mm')} ~{' '}
                  {dayjs(item.workEndDate).format('HH:mm')}
                </span>
              </div>

              <p className="mb-1 truncate text-xs text-slate-500">
                {item.constructionNm}
              </p>

              <div className="flex items-center gap-1.5">
                <span className="inline-flex items-center rounded-md bg-slate-50 px-2 py-1 text-xs font-medium text-slate-600">
                  {item.workTypeNm}
                </span>
              </div>
            </div>
            {item.gubun === '승인' &&
              item.userId === userInfo?.decUserId &&
              item.extensionApplication === 'N' && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    dispatch(PermitActions.setExtendData(item));
                    dispatch(
                      BottomSheetActions.SetBottomSheetState({
                        bottom: true,
                        type: 'extend',
                      })
                    );
                  }}
                  className="text-primary border-primary active:bg-primary absolute right-3 bottom-3 rounded-lg border bg-white px-3 py-1 text-xs font-bold transition-colors active:text-white"
                >
                  연장 신청
                </button>
              )}
          </li>
        ))}
      </ul>

      {bottomSheetState.type === 'extend' && (
        <ExtendBottomSheet SaveLogic1={SaveLogic1} />
      )}
    </>
  );
}
